import { FC, ReactNode } from 'react';

import { useFeatureFlag } from '../hooks';

type FeatureFlagProps = {
	children: ReactNode;
	fallback?: ReactNode;
	flag: string;
};

export const FeatureFlag: FC<FeatureFlagProps> = ({ children, fallback, flag }) => {
	const isEnabled = useFeatureFlag(flag);

	if (!isEnabled) {
		return fallback || null;
	}

	return children;
};

// Opposite of feature flag hides elements if the flag is enabled
export const FeatureMask: FC<FeatureFlagProps> = ({ children, fallback, flag }) => {
	const isEnabled = useFeatureFlag(flag);

	if (isEnabled) {
		return fallback || null;
	}

	return children;
};
